import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { SpecialReport } from './components/SpecialReport';
import { SectionArticles } from './components/SectionArticles';
import { FocusSection } from './components/FocusSection';
import { ReelTalk } from './components/ReelTalk';
import { IconicSection } from './components/IconicSection';
import { RankingsSection } from './components/RankingsSection';
import { BrandsVideoSection } from './components/BrandsVideoSection';
import { RankingArticles } from './components/RankingArticles';
import { TrendsTags } from './components/TrendsTags';
import { Footer } from './components/Footer';
import { useGptInit } from './hooks/useGptInit';
export function App() {
  useGptInit('Homepage');
  return <div className="min-h-screen bg-white w-full overflow-x-hidden font-['Poppins']" data-id="element-0">
      {/* ═══ HEADER ═══ */}
      <Header data-id="element-1" />

      {/* ═══ TOP AD BANNER ═══ */}
      <div className="w-full flex items-center justify-center" style={{
      marginTop: '37px',
      marginBottom: '23px',
      padding: '0 20px'
    }} data-id="element-2">
        <div className="has-radius" style={{
        background: '#D9D9D9',
        borderRadius: '18px',
        padding: '0 87px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '100%'
      }} data-id="element-3">
          <img src="https://cdn.magicpatterns.com/uploads/aRvEPA7nKDuo2o2MzgvBvi/Leaderboard_728x90.png" alt="Leaderboard Ad" style={{
          maxWidth: '728px',
          width: '100%',
          height: 'auto',
          display: 'block'
        }} data-id="element-4" />
        </div>
      </div>

      {/* ═══ HERO SECTION ═══ */}
      <HeroSection data-id="element-5" />

      {/* ═══ SPECIAL REPORT ═══ */}
      <SpecialReport data-id="element-6" />

      {/* ═══ SECTION ARTICLES (BRANDS/AGENCIES) ═══ */}
      <SectionArticles data-id="element-7" />

      {/* ═══ FOCUS SECTION ═══ */}
      <FocusSection data-id="element-8" />

      {/* ═══ REEL TALK ═══ */}
      <ReelTalk data-id="element-9" />

      {/* ═══ BEST BRANDS & MARKETERS ═══ */}
      <RankingsSection data-id="element-10" />

      {/* ═══ ICONIC ═══ */}
      <IconicSection data-id="element-11" />

      {/* ═══ BEST BRANDS VIDEO ═══ */}
      <BrandsVideoSection data-id="element-12" />

      {/* ═══ RANKING ARTICLES ═══ */}
      <RankingArticles data-id="element-13" />

      {/* ═══ TRENDS TAGS ═══ */}
      <TrendsTags data-id="element-14" />

      {/* ═══ LOGO BEFORE FOOTER ═══ */}
      <div className="flex justify-center px-6 lg:px-4" style={{
      marginBottom: '40px'
    }} data-id="element-15">
        <img src="https://cdn.magicpatterns.com/uploads/jXZbuP4JpR1bBw61Qwmybj/com-logo-left.png" alt="Communicate" className="object-contain h-[45px] md:h-[65px] lg:h-[87px]" data-id="element-16" />
      </div>

      {/* ═══ FOOTER ═══ */}
      <Footer data-id="element-17" />
    </div>;
}